export default __webpack_public_path__ + "static/media/BG-LightBlue-0003.c3ab2c7a.png";